namespace Gamification.Gamification {
    export interface UtentiProdottiClassificheForm {
        IdUtenteProdotto: Serenity.IntegerEditor;
        IdentifierUtenteProdottoClassifica: Serenity.StringEditor;
        Tipo: Serenity.EnumEditor;
        IdProdottoEsperienza: Serenity.LookupEditor;
        Nome: Serenity.StringEditor;
        Limitazione: Serenity.IntegerEditor;
    }

    export class UtentiProdottiClassificheForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.UtentiProdottiClassifiche';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiProdottiClassificheForm.init)  {
                UtentiProdottiClassificheForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.LookupEditor;

                Q.initFormType(UtentiProdottiClassificheForm, [
                    'IdUtenteProdotto', w0,
                    'IdentifierUtenteProdottoClassifica', w1,
                    'Tipo', w2,
                    'IdProdottoEsperienza', w3,
                    'Nome', w1,
                    'Limitazione', w0
                ]);
            }
        }
    }
}
